module.exports = __webpack_public_path__ + "img/BR.0da76eab.png";